export default {
  home: {
    myNft: '我的票券',
    myEvent: '我的活動',
    empty: {
      text: '您沒有持有的票券\n瀏覽各式活動並新增吧',
      btn: '瀏覽活動',
    },
  },
  discover: {
    headerTitle: '探索',
    events: '活動',
    empty: {
      text: '沒有搜尋到任何活動。'
    },
    mySale: '我的銷售商品',
  },
  discoverDetail: {
    title: '銷售票券詳細資訊',
    eventTitle: '活動詳細資訊',
    listTab: '重新銷售',
    detailTab: '活動詳細資訊',
    noticeTab: '公告',
    more: '更多票券',
    detail: '詳細資訊',
    eventInfo: '活動資訊',
    saleEnd: '銷售已結束',
    applyEnd: '招募已截止',
    applied: '您已參與此應募活動。',
    applyModify: '確認/修改我的應募內容',
    needLogin: '這是需要登入的服務',
    notice: '公告',
    selectCrcy: '選擇支付貨幣',
  },
  paySelect: {
    dateTitle: '選擇日期 & 時間',
    title: '選擇{type}',
    dateForm: 'YYYY.MM.DD (ddd) A hh:mm',
    timeForm: 'A hh:mm',
    selectDate: '選擇日期',
    selectTime: '選擇時間',
    selectOption: '選擇選項',
    selectSeat: '選擇座位',
    selectSeatNum: `共選擇 {total} 個座位`,
    selectSeatCplt: '確認選擇座位',
    buyerInfo: '購買者資訊',
    seat: '個座位',
    empty: '沒有可選擇的項目。',
    customer: {
      title: '為了提供您票券預訂資訊，\n請輸入您的聯絡方式。',
      desc: '通知訊息將透過 KakaoTalk 或簡訊發送。',
    },
    qtnr: {
      title: '請提供活動參與所需的\n事前資訊。',
    },
    ntfc: {
      leftUpdated: '剩餘數量已變更。',
    },
  },
  payDetail: {
    title: '結帳',
    confirm : '請確認以下內容是否正確。',
    order: '請確認您欲結帳的 {type} 資訊',
    pay: '付款資訊',
    doPay: '結帳',
    price: '結帳金額',
    buyNow: '立即購買',
    joinNow: '立即參加',
    applyNow: '立即應募',
    credits: '剩餘使用量',
    venue: '地點',
    dateTime: '日期時間',
    secondSale: '二次銷售',
    allowTransfer: '允許轉讓',
    info: '{type} 購買資訊',
    buyerInfo: '購買者資訊',
    ableToResell: '可重新銷售',
    unableToResell: '不可重新銷售',
    ableToTransfer: '可轉讓',
    unableToTransfer: '不可轉讓',
    royalties: '版權費',
    maxPrice: '最高價格',
    soldOut: '已售完',
    maxPur: '超過最大購買數量',
    total: '總計',
    totalTicket: '共 {count} 張票券',
    sheets: '{count} 張',
    bookingFee: '預訂手續費',
    dcDetail: '折扣明細',
    maxCnt: '最大購買數量',
    stock: '剩餘',
    calculating: '計算中...',
    crcySelect: '選擇貨幣',
    crcyPay: '使用 {0} 支付',
    toPaypal: {
      title: 'PayPal 付款',
      desc: '選擇後可使用 PayPal 付款。',
    },
    timeLeft: '剩餘時間',
    preparing: '準備付款中...',
    onlyMmbs: '會員專屬活動。',
    eligibleMmbs: '可參與的會員',
  },
  payResult: {
    modalTitle: '結帳',
    paying: '票券購買進行中',
    issuing: '購買中..\n請勿關閉視窗',
    issuingText: '請稍候',
    issueCplt: '購買成功',
    issueFail: '購買失敗',
    issueFailText: '購買處理時發生錯誤。\n請稍後再試',
    waitMinute: '最長等待時間：{minute} 分鐘',
    payCplt: '購買完成',
    payCpltText: '購買已完成',
    refund: '退款',
    retry: '重新嘗試',
    ntfc: {
      refundCplt: '已完成退款處理。',
    },
  },
  refundAlert: {
    title: '您確定要退款嗎？',
  },
  wc: {
    connected: '錢包已連接',
    disconnect: '斷開連接',
    readyReq: '請連結錢包以使用 {0} 支付',
    connect: '連結錢包',
    payAmount: '支付金額',
    doPay: '點擊以簽署支付',
    openWallet: '請打開錢包應用程式以完成簽名',
    recording: '正在記錄交易。請稍候...',
    returnReq: '簽名完成後，請使用返回鍵回到此處確認結果。',
    returnConnect: '連結錢包後，請點擊返回回到此處查看結果。',
    loadingWallet: '正在載入錢包模組...',
    availWallet: '可支付錢包',
    selectNetwork: '請選擇網路',
    payWarn: `
* 各網路的手續費（Gas Fee）與處理速度可能有所不同。
* 請僅透過 Move Ticket 支援的網路進行傳輸。
* 使用其他網路時，資產可能會遺失。
`,
    warn: {
      noBal: '餘額不足。',
      pause: '支付已暫停。',
      disconnectFailed: '斷開連接失敗。',
      connectFailed: '連接失敗。',
      expired: '支付時間已過期。\n請再試一次。',
    }
  },
  listFilter: {
    title: '篩選',
    sort: '排序依據',
    status: '票券狀態',
    new: '最新順序',
    old: '最舊順序',
    available: '可使用',
    used: '已使用',
    all: "全部",
  },
  start: {
    start: "開始使用 moove",
    register: "註冊",
    isRegister: "還沒有帳號嗎？",
    loginEmail: "使用電子郵件帳號登入",
    loginKakao: "使用 Kakao 登入",
    loginGoogle: "使用 Google 登入",
  },
  login: {
    login: "登入",
    saveLogin: "記住登入資訊",
  },
  register: {
    register: "註冊",
    loginEmail: "使用電子郵件帳號登入",
    registerKakao: "使用 Kakao 開始",
    registerGoogle: "使用 Google 開始",
    registerEmail: "使用電子郵件帳號註冊",
    mooveAgree: "同意 moove 服務條款",
    indvAgree: "同意個人資訊蒐集與使用",
    marketingAgree: "同意接收行銷訊息",
    isLogin: "已經有帳號了嗎？",
    success: ["歡迎您成為會員！", ""],
    configCode: "設定驗證密碼",
    phoneConfig: '輸入手機號碼',
    continue: '繼續',
  },
  registerExternal: {
    kakao: "使用 Kakao 帳號註冊",
    google: "使用 Google 帳號註冊",
    title: ["若要繼續，", "需要同意資訊。"],
    process: "請確認資訊後同意。",
    continue: "繼續進行會員註冊",
  },
  emailWait: {
    title: ["請驗證您的電子郵件", "以完成會員註冊"],
    process: [
      "驗證郵件已發送至您註冊的電子郵件地址。",
      "請驗證您的電子郵件以完成會員註冊。",
      "此連結將在 24 小時後過期。",
    ],
    status: "等待電子郵件驗證中...",
  },
  emailExpired: {
    title: ["電子郵件驗證連結", "已過期"],
    process: [
      "此驗證連結已過期。",
      "請點擊下方按鈕",
      "重新發送驗證連結並完成驗證。",
    ],
    resend: "重新發送驗證連結",
  },
  pwConfig: {
    title: "請輸入密碼",
    confirmTitle: ["請再次輸入", "您的密碼"],
    nextFaceId: "下次使用 Face ID",
    newPwd: "請輸入新密碼",
    newPwdConfirm: ["請再次輸入", "您的密碼"],
  },
  forgotPwd: {
    title: "找回密碼",
    ask: "忘記密碼了嗎？",
    enterEmail: "請輸入您的電子郵件地址",
    confirmEmail: "請確認您的電子郵件",
    explain:
        "請輸入您註冊時使用的電子郵件地址，以重設您的密碼。",
    backToSignIn: "返回登入",
    sentExplain: "密碼重設連結已發送至以下電子郵件地址。",
  },
  resetPwd: {
    title: "重設密碼",
    submit: "重設密碼",
    ntfc: {
      pwdResetFailed: "密碼變更失敗。",
      pwdResetSuccess: "密碼已變更！",
    },
  },
  footer: {
    info: `
    (주)개런터블
    營業登記號碼 575-87-02196
    通訊販售業者申報號碼 第2025-首爾廣津-0208號
    05005 首爾特別市廣津區廣灘路 17 街 14-4, 101 號
    代表理事 李東柱
    info{'@'}moove.live 02-6959-9998
    
    Guarantable Pte. Lte
    (Singapore) 8 Marina View, #39-04, Asia Square Tower1
    `,
    service: '服務條款',
    indv: '隱私權政策',
  },
  footerMenu: {
    nft: "票券",
    search: "探索",
    ticket: "票券",
    scan: "掃描",
    coupon: "優惠券",
    profile: "設定",
    viewCltn: "依收藏查看",
    viewNft: "依票券查看",
  },
  period: {
    unlimited: '無期限',
    max: '最長期限',
    forDays: '{0} 天後',
    forAMonth: 'For a month',
    forMonths: 'For {0} months',
  },
  nftMenu: {
    title: '更多',
    sell: '銷售票券',
    send: '轉讓票券'
  },
  saleNft: {
    title: '設定票券銷售',
    period: '銷售截止日',
    noTimeLimit: '無期限',
    setDate: '選擇銷售截止日',
    endOfSaleDate: '選擇的銷售截止日：{0}',
    selectDate: '請選擇銷售截止日',
    saleBefore: '將銷售至 {0}。',
    beforeTimeFormat: 'YYYY. MM. DD',
    beforeDateTimeFormat: 'YYYY. MM. DD A h:mm',
    select: '選擇完成',
    register: '登記銷售',
    modify: '修改銷售資訊',
    sellingTitle: '票券銷售中',
    cancel: '取消銷售',
    cancelConfirm: '您確定要刪除嗎？',
    viewDetail: '查看銷售文章',
    myNftList: '我的票券',
    moveToMarket: '前往市場',
    registering: '登記銷售中',
    regCplt: '登記銷售成功',
    regCpltText: '已成功登記銷售。',
    regFail: '登記銷售失敗',
    regFailText: '您要重新嘗試登記銷售嗎？\n' +
        '如果您不想再進行登記銷售，\n' +
        '請選擇取消登記銷售。',
    regCancel: '取消登記銷售',
    regRetry: '重新嘗試',
    cautionTitle: '票券詳細資訊',
    ntfc: {
      canceled: '已取消銷售登記。',
      modified: '已修改銷售資訊。',
      notInfo: '沒有銷售資訊。',
    },
    modalTitle: '登記銷售',
    willReceive: "銷售時結算金額",
    buyerPay: "買家支付金額",
    priceDesc: '請設定 {type} 的銷售價格',
  },
  saleNftDetail: {
    title: '票券銷售詳細資訊',
    remaining: '剩餘使用量',
    price: '銷售價格',
    edit: '編輯',
    delete: '刪除',
    expDate: '有效期限',
    coupons: '剩餘優惠券',
    venue: '活動地點',
    cautions: '詳細資訊',
    until: '至 {0}',
    couponCount: '{count} 張',
    available: '可使用',
    used: '已使用',
  },
  nftImage: {
    title: '查看票券'
  },
  nftType: {
    all: "全部",
    MEMBERSHIP: "會員資格",
    TICKET: "票券",
    mmbsCount: '{0} 個會員資格',
    ticketCount: '{0} 張票券'
  },
  qrCard: {
    title: "掃描 QR Code 開始",
    scan: "掃描 QR Code",
  },
  nftQtnr: {
    title: '在收到票券之前，\n請填寫事前資訊。',
    submit: '完成資訊輸入',
  },
  qtnrInput: {
    default: {
      name: '姓名',
      email: '電子郵件',
      phone: '手機號碼',
      aflt: '所屬單位',
      dpmt: '部門',
      pstn: '職位',
      nick: '暱稱',
      birth: '出生年月日',
      etc: '請輸入其他事項。',
    },
    plhd: {
      email: '請輸入您的電子郵件',
      aflt: '請輸入您的所屬單位',
      dpmt: '請輸入您的部門',
      pstn: '請輸入您的職位',
      nick: '請輸入您的暱稱',
      name: '請輸入您的姓名',
      phone: '請輸入您的手機號碼（僅限數字）',
      birth: 'YYYYMMDD',
    },
  },
  nftDetailHistory: {
    title: '票券歷史記錄',
    nftTab: '票券使用記錄',
    ownerTab: '所有權變更記錄'
  },
  nftHistory: {
    title: "票券使用記錄",
    payTitle: "票券支付使用記錄",
    close: "關閉票券記錄",
    issued: "已發行",
    nftUse: "已使用 {0}",
    benefitUse: "已使用優惠券",
    next: "等待下次使用",
    waiting: "等待中...",
    network: "{networkName} {title}",
    timesCount: '已使用 {0} 次',
    useCount: '已使用 {0} 個',
    remain: '剩餘',
    times: '次',
    available: '可使用',
    used: '已使用',
    useHistory: '已使用 {0} 次',
    cancelHistory: '已取消使用',
    unlimited: '無限次',
  },
  couponHistory: {
    title: "優惠券使用記錄",
    modalTitle: "優惠券使用記錄",
    canUse: "可使用",
    used: "已使用",
    total: "全部",
    coupon: "優惠券",
    use: "使用優惠券",
    noData: "沒有使用過的優惠券記錄。",
    allUsed: "優惠券已全數使用完畢。",
    couponUse: '已使用優惠券：{0}',
    expired: '優惠券已過期：{0}',
    useFail: '使用失敗：{0}',
  },
  payHistory: {
    monthUse: '{0} 月使用金額',
    accUse: '累積使用金額',
  },
  historyType: {
    INVITED: `已邀請 {type}`,
    AUTH: '驗證',
    MINTED: '已發行 {0}',
    SEND: '已轉讓 {0}',
    SELL: '已銷售 {0}',
    FIRST_BUY: '首次購買',
    USE: '已使用 {0}',
    USE_CANCEL: '已取消使用 {type}',
    EXPIRED: '已過期',
    USE_FAIL: '使用失敗',
    SEND_FAIL: '轉讓失敗',
    SELL_REG: '登記銷售',
  },
  nftCard: {
    seatMap: '查看座位',
    seat: '座位',
    lock: "已鎖定",
    used: "已使用",
    sending: "轉讓中",
    sendingLogo: '票券轉讓中..',
    sendingFailed: '轉讓失敗',
    selling: '銷售中',
    regitSelling: '登記銷售中',
    regitSellingFail: '登記銷售\n失敗',
    solving: '解決',
    expired: "已過期",
    failed: '生成失敗',
    monthUse: '{0} 月使用金額',
    nameDateForm: 'M/D A hh:mm',
    entry: '報名人數',
    status: {
      TICKET: {
        used: "此票券已使用完畢。",
        expired: "此票券已過期。",
        lock: "活動當日將解除鎖定。",
      },
      MEMBERSHIP: {
        used: "您已使用完所有會員資格。",
        expired: "會員資格已過期。",
        lock: "活動當日將解除鎖定。",
      },
      loading: {
        title: '{type} 載入中..',
        desc: '請稍候\n最長等待時間：8 分鐘',
      },
      fail: {
        title: '發行失敗',
        purDesc: '發行時發生錯誤。\n您要重新嘗試嗎？',
        qrDesc: '發行時發生錯誤。\n您要重新嘗試嗎？',
      },
      qtnr: {
        required: '填寫主辦單位要求的額外資訊後，\n即可完成票券發行。',
        submit: '輸入參與者額外資訊',
      },
      wait: {
        required: '公佈中獎者後方可參加活動。',
      },
      seat: {
        required: '選擇座位後\n即可入場。',
        submit: '選擇座位',
        time: '座位選擇時間',
      }
    },
    eventLock: {
      title: '尚無法使用',
      activeTime: 'QR Code 啟用時間',
      timeFormat: 'YYYY. MM. DD (ddd) A hh:mm',
    },
    precautionTitle: "詳細資訊",
    precaution: {
      avail: '允許',
      unAvail: '不允許',
      tabs: {
        attendee: '參與者額外資訊',
        nft: '票券資訊',
      },
      reSale: {
        title: '重新銷售資訊',
      },
      transfer: {
        title: '轉讓狀態',
      },
      description: {
        title: "詳細資訊",
        empty: "沒有詳細資訊。"
      },
      considerations: {
        title: "注意事項",
        empty: "沒有注意事項。"
      },
      qtnr: {
        title: '參與者資訊',
        modifyAsk: '我可以變更參與者的額外資訊嗎？',
        modifyReq: '請求變更',
      },
    },
    tag: {
      mmbs: '會員資格',
      ticket: '票券',
    },
    qpass: {
      sent: '入場券已發送至您的手機。',
      resent: '入場券已重新發送至您的手機。',
    },
  },
  seatMap: {
    title: '查看座位位置',
  },
  couponDetail: {
    until: '至 {date}',
    noticeButton: "注意事項",
    notices: {
      place: '使用地點',
      title: "注意事項",
      basic: '基本注意事項',
      extra: '額外注意事項',
    },
    lock: {
      title: '尚無法使用',
      activeTime: '條碼啟用時間',
    },
  },
  couponStatus: {
    unuse: '可使用',
    used: '已使用',
    expired: '已過期',
    deactive: '暫停',
    active: '使用中',
  },
  qrScan: {
    myProfileQr: "我的個人資料 QR Code",
    suggest: "使用 QR Code 立即\n傳送和接收票券",
  },
  receiveNft: {
    slide: "滑動以驗證所有權",
    request: "請求所有權驗證",
    recording: "記錄至區塊鏈中",
    auth: {
      MEMBERSHIP: "會員資格驗證",
      TICKET: "票券驗證",
    },
    passcode: {
      MEMBERSHIP: "會員資格驗證碼",
      TICKET: "票券驗證碼",
    },
  },
  ticketDetail: {
    sector: "區域",
    row: "排",
    seat: "座位號碼",
    date: "日期",
    time: "時間",
    location: "地點",
    dateFormat: 'YYYY. MM. DD/A hh:mm',
  },
  myProfile: {
    title: "我的個人資料",
    editProfile: "編輯",
    deleteProfile: '刪除個人資料',
    invite: '邀請朋友',
    tabs: {
      profileInfo: "個人資料資訊",
      password: "密碼",
    },
    edit: "變更",
    ntfc: {
      editNickname: "暱稱已\n變更。",
      editPwd: "密碼已\n變更。",
      authPwd: "驗證密碼已\n變更。",
    },
    config: {
      changeAuthPwd: "變更驗證密碼",
      change2Step: "兩步驟驗證",
      changeLanguage: "變更語言",
      currentLanguage: "目前語言",
      chooseLanguage: "選擇語言",
      myTrst: '我的交易紀錄',
    },
    deleteProfileImg: {
      explain1: '您確定要刪除此個人資料照片嗎？',
      explain2: '您確定要刪除此個人資料照片嗎？',
      delete: '刪除',
      cancel: '取消'
    },
    qrText: "您可以使用此代碼接收票券",
    forgetPwd: "忘記密碼",
    twoStepAuthText:
        "驗證碼將發送至您註冊的電子郵件。今後，每當您在未知裝置上登入時，系統將要求您輸入驗證碼。",
    twoStepInput: ["請輸入發送至電子郵件的", "6 位數字驗證碼。"],
    isHavePwdCode: "沒有收到驗證碼嗎？",
    qrName: "{name} 的 QR Code",
  },
  withdraw: {
    title: '會員註銷',
    header: '您好，尊貴的會員。\n如果您想註銷會員，請參考以下資訊。',
    detail: `- 會員註銷後將無法再次加入。`,
    ifDisable: '- 在進行中的活動結束之前無法註銷會員，如果您想立即註銷，請透過以下電子郵件聯繫我們。',
    footer: '如果您確實想註銷您的 Moove Wallet，請點擊下方的「註銷會員」按鈕。',
  },
  myTrst: {
    purHistory: '購買紀錄',
    saleHistory: '銷售紀錄',
    orderHistory: '訂單紀錄',
    detail: '查看詳情',
  },
  orderEdit: {
    title: "確認訂單資訊",
    edit: "修改訂單資訊",
    edited: "訂單資訊已修改",
    editError: "修改時發生錯誤"
  },
  sendNft: {
    title: "轉讓票券",
    sendByEmail: "透過電子郵件傳送",
    sendByQrCode: "透過 QR Code 傳送",
    emailWill: ["以下電子郵件帳戶", "將寄送票券。"],
    emailInputPlhd: '請輸入收件人的電子郵件帳號。',
    emailWarning: "票券所有權將變更為收件人帳戶，且不可退款。",
    confirmText: [
      "您確定要將",
      "'{name}' {type} 傳送給",
      "{receiver} 嗎？",
    ],
    success: "傳送完成！",
    loading: "記錄至區塊鏈中",
  },
  receivePending: {
    title: '驗證資訊中..',
  },
  receiveNtfc: {
    title: "通知",
    nftReceive: {
      text: '{sender} 傳送了\n「{name}」{type}。',
    },
    userInvite: {
      text: '傳送邀請訊息的 {0} 님\n已加入 Moove。',
    },
    saleCplt: {
      title: "票券銷售完成",
      text: '銷售已完成。'
    }
  },
  twoStepAuth: {
    verify: {
      title: "需要兩步驟驗證",
      explain: [
        "請輸入透過電子郵件收到的 6 位數字驗證碼，",
        "然後點擊下方的「驗證」按鈕。",
      ],
    },
  },
  invite: {
    header: '邀請朋友',
    title: '立即邀請朋友加入 Moove！',
    desc: '透過電子郵件發送邀請函或複製連結進行邀請。',
    copy: '複製邀請連結',
    ntfc: {
      copied: '已複製邀請連結！',
      success: '邀請訊息已透過電子郵件發送！',
      fail: '訊息傳送失敗，請重新嘗試。',
    },
  },
  cltnDetail: {
    createdBy: "由 {0} 建立",
    description: "說明",
    showMore: "查看更多",
    showLess: "收起",
    ntfc: {
      linkCopy: '活動連結已複製！'
    },
  },
  brandDetail: {
    brand: "品牌",
    website: "網站",
    cltns: "收藏",
    viewMore: "查看更多",
    moreAbout: "更多關於",
    readMore: "閱讀更多",
    showMore: "查看更多",
    showLess: "收起",
  },
  adultIdentify: {
    title: '僅限 19 歲以上人士參與活動應募。',
    desc: `若要參與此活動，
      需要年滿 19 歲以上的成人驗證。
      為保護青少年，即使登入後
      也需要進行額外的成人驗證程序，
      完成成人驗證後才能應募。`,
    action: '進行成人驗證',
  },
  eventApply: {
    contentTitle: '我的活動應募內容',
    intro: '請輸入您的活動應募內容。',
    success: '申請已完成！',
    modSuc: '修改已完成！',
    update: '修改應募內容',
  },
  search: {
    placeholder: "請輸入搜尋關鍵字。",
    noResult: "沒有搜尋結果。",
    noSearchValue: "請輸入搜尋關鍵字",
    search: "搜尋",
    recentSearch: "最近搜尋",
    searching: "搜尋中",
    thereIsNoResult: "沒有 {0} 的搜尋結果。",
  },
  trstList: {
    buyCnt: '購買次數',
    sellCnt: '銷售次數',
    cancelPur: '取消購買',
  },
  cancelPur: {
    title: '取消購買',
    ask: '您確定要取消所選的購買項目嗎？',
    cancel: '取消購買',
    refundPrice: '預計退款金額',
    payPrice: '商品金額',
    ticketPrice: '票券金額',
    bookingFee: '預訂手續費',
    cancelFee: '取消手續費',
    fail: '取消購買失敗，請重新嘗試。',
    success: '取消購買已完成。',
    exceptFee: '預訂手續費不予退還。',
  },
  blockEmail: {
    notExist: "無電子郵件發送紀錄。",
    allowed: "已允許接收行銷郵件資訊。",
    canceled: "已取消接收行銷郵件資訊。",
    allow: "允許接收行銷郵件資訊",
    cancel: "取消接收行銷郵件資訊",
  },
  filter: {
    recent: "最近註冊",
    old: "最舊",
    name: "名稱",
  },
  currency: {
    krw: '韓元',
    krwUnit: '{0} 韓元',
    usd: '美元',
    usdUnit: '$ {0}',
    eur: '歐元',
    eurUnit: '€ {0}',
    sgd: '新加坡元',
    sgdUnit: 'S$ {0}',
    jpy: '日圓',
    jpyUnit: '¥ {0}',
    twd: '新台幣',
    twdUnit: 'NT$ {0}',
    xrp: 'XRP',
    xrpUnit: '{0} XRP',
    usdt: 'USDT',
    usdtUnit: '{0} USDT'
  },
  address: {
    address: '地址',
    detail: '詳細地址',
    postalCode: '郵遞區號',
  },
  common: {
    email: "電子郵件地址",
    nickName: "暱稱",
    pw: "密碼",
    currentPw: "目前密碼",
    newPw: "新密碼",
    pwConfirm: "確認密碼",
    required: "必填",
    optional: "選填",
    agree: "同意",
    disagree: "不同意",
    nft: "NFT",
    nftBenefit: "活動優惠",
    validUntil: "有效期至 {date}",
    activeDate: '啟用日期 {date}',
    network: "網路",
    address: "地址",
    contract: "合約",
    wallet: "錢包",
    walletAddress: "錢包地址",
    nickname: "暱稱",
    ok: "確認",
    cancel: "取消",
    save: "儲存",
    refresh: "重新整理",
    share: "分享",
    download: "下載",
    logout: "登出",
    send: "傳送",
    resend: "重新傳送",
    verify: "驗證",
    collection: "收藏",
    collections: "收藏",
    counts: "個",
    count: "個",
    confirm: "確認",
    invite: "邀請",
    apply: '套用',
    more: '更多',
    event: '活動',
    next: '下一步',
    price: '價格',
    open: '公開',
    platformFee: '平台手續費',
    max: '最大',
    period: '期間',
    phone: '手機號碼',
    free: '免費',
    soldOut: '已售完',
    applying: '招募參與者中',
    ticket: '票券',
    close: '關閉',
    select: '選擇',
  },
  dateFormat: {
    infoDate: 'YYYY-MM-DD A h:mm',
    commonDate: 'YY. MM. DD (ddd) A hh:mm'
  },
  network: {
    KLAYTN: "Klaytn",
    POLYGON: 'Polygon',
    XRPL_EVM: 'XRPL EVM',
  },
  status: {
    used: "已使用",
    expired: "已過期",
  },
  taxItem: {
    platform: '平台手續費',
    etc: '其他',
  },
  orderStatus: {
    buy: '已完成付款',
    refund: '已完成退款'
  },
  valid: {
    required: "為必填項目",
    pwdConfirm: "密碼不符。",
    email: "電子郵件格式不正確。",
    noEmail: "請輸入您要傳送票券的電子郵件地址。",
    notMyEmail: '這是您目前的票券持有者帳號。請輸入其他電子郵件地址。',
    notUser: "帳號不存在。",
    invalidAccInfo: "帳號或密碼錯誤。",
    invalidPw: "密碼錯誤。",
    expiredRequest: "請求已過期",
    registered: '此使用者已註冊。',
    code6: '請輸入完整的 6 位數字。',
    codeRequired: '請輸入驗證碼。',
    pwdRequirements: '至少 8 個字元，包含至少一個小寫字母、數字、符號或空格。',
    moreThan: '必須大於 {max}',
    integer: '僅能輸入整數。',
    posTwo: '僅能輸入至小數點後兩位。',
    phone: '請輸入不含「-」的號碼。',
    phoneFormat: '請輸入有效的號碼。',
    birthFormat: '請照 YYYYMMDD 的格式輸入',
    maxLength: '最多可輸入 {max} 個字元。',
    minSelect: `請至少選擇 {min} 個。`,
    fileType: '不允許此檔案格式',
    refCode: '代碼無效',
  },
  ntfc: {
    expiredLink: '連結已過期。',
    resendEmail: "電子郵件已重新發送。",
    existEventNft: "此帳號已收到票券。",
    incorrectPasscode: "驗證碼不正確",
    twoStepActivated: "兩步驟驗證已啟用",
    twoStepDeactivated: "兩步驟驗證已停用。",
    walletCopied: "錢包地址已複製",
    logout: "已成功登出。",
    notVerifiedEmail: '尚未驗證的電子郵件。',
    authExpired: '驗證資訊已過期。請重新發送驗證郵件。',
    expiredPasscode: '驗證碼已過期。請重新發送電子郵件。',
    qrMintingLimit: '此代碼無法再發行票券。',
    issuingLimit: '票券數量不足，無法完成購買。',
    perWalletLimit: '已超過每個帳號的購買數量限制。',
    alreadyInvited: '此使用者已被邀請。',
    recordingFailed: '區塊鏈記錄失敗，請稍後再試。',
    invalidPeriod: '活動期間以外無法使用。',
    sendError: '傳送時發生錯誤。',
    regError: '註冊時發生錯誤。',
    payError: '付款時發生錯誤。',
    refundError: '退款時發生錯誤。',
    invalidEvent: '無效的活動。',
    alreadyReservedSeat: '此座位已被他人選取，請選擇其他空位。',
    seatTimeOut: '付款有效時間已過期，請重新進行。',
    seatTotalMax: '最多可選擇 {count} 個座位。',
    zoneTotalMAx: '最多可購買 {count} 個座位。',
    payInfoError: '商品資訊已過期，\n請重新進行。',
    notOwned: '這不是您擁有的商品。',
    nonRefundable: '此商品不可退款。',
    profileImg: '傳失敗。\n請檢查以下圖片規格：\n大小：5MB 以下\n副檔名：jpg, jpeg, png, webp',
    noTicketAcc: "該帳號沒有對應的票券。",
    sessionExpired: '工作階段已過期。請再試一次。',
  },
  plhd: {
    enterPasscode: "請輸入驗證碼",
    enterPwd: "請輸入密碼",
    emailPlhd: "example{'@'}gmail.com",
    friendEmail: '請輸入朋友的電子郵件地址',
    phone: '請輸入不含「-」的號碼。',
  },
  modal: {
    sendingNft: {
      title: '傳送票券中',
      desc: '票券傳送中，請稍候。'
    },
    sendingFail: {
      title: '票券傳送失敗',
      desc: '票券傳送失敗。',
      cancel: '取消傳送',
      retry: '重新嘗試',
      ntfc: {
        canceled: '已取消傳送。'
      },
    },
    qrMintFail: {
      title: '票券生成失敗',
      desc: '票券生成失敗，請重新嘗試。',
      success: '票券已生成。'
    },
    qtnrModify: {
      title: '請將需要變更的資訊\n發送至以下電子郵件地址。',
      desc: '電子郵件地址：{email}',
    }
  },
  inAppRoute: {
    desc: '由於應用程式內瀏覽器相容性問題，無法使用 Google 登入。\n\n請嘗試其他登入方式，或點擊下方按鈕複製連結，然後開啟預設瀏覽器並將連結貼到網址列。',
    copy: '複製連結',
    copied: '連結已複製！\n請開啟預設瀏覽器後，將連結貼到網址列。',
  },
};
